import { lazy } from 'react';
const VerPlan = lazy(() => import('./VerPlan'));

const VerPlanRoute = [
  {
    path: '/verplan',
    component: VerPlan
  }
];

export default VerPlanRoute;
